<template>
	<SplashScreen :show="loading" />
	<GlobalCookieBanner />
	<GlobalMobileAppBanner />
	<SearchDialog v-if="isLogged" />
	<LayoutSettings v-if="showLayoutSettings" />
	<GlobalExamReportShareModal />
	<GlobalAppointmentFormModal v-if="isLogged" />
	<GlobalMfaModal />
	<GlobalTotpSetupModal />
</template>

<script lang="ts" setup>
import { computed, onBeforeMount, ref } from "vue"
import SplashScreen from "@/app-layouts/common/SplashScreen.vue"
import LayoutSettings from "@/components/common/LayoutSettings.vue"
import SearchDialog from "@/components/common/SearchDialog.vue"
import GlobalAppointmentFormModal from "@/components/global/GlobalAppointmentFormModal.vue"
import GlobalCookieBanner from "@/components/global/GlobalCookieBanner.vue"
import GlobalExamReportShareModal from "@/components/global/GlobalExamReportShareModal.vue"
import GlobalMfaModal from "@/components/global/GlobalMfaModal.vue"
import GlobalMobileAppBanner from "@/components/global/GlobalMobileAppBanner.vue"
import GlobalTotpSetupModal from "@/components/global/GlobalTotpSetupModal.vue"
import { emitter } from "@/emitter"
import { useAuthStore } from "@/stores/auth"

const { showLayoutSettings } = defineProps<{
	showLayoutSettings?: boolean
}>()

const authStore = useAuthStore()

const loading = ref(true)
const isLogged = computed(() => authStore.isLogged)

onBeforeMount(() => {
	setTimeout(() => {
		loading.value = false
	}, 500)
})

// TODO-NEXT: MVP2 implementare la richiesta di invito
emitter.on("open:invitation-request", params => {
	console.warn("open:invitation-request", params)
})
</script>
